/**
 * Voice alert admin — contract paths for settings voice panel.
 */

import { buildContractPath } from "./api/contract-client.js";

export const VOICE_CONSOLE_TIMEOUT_MS = 20000;

export function buildGetAdminVoiceTemplatesPath() {
  return buildContractPath("get__admin_voice_templates");
}

/** @param {string} name */
export function buildPutAdminVoiceTemplatePath(name) {
  return buildContractPath("put__admin_voice_templates_p", {
    path: { param: String(name || "").trim() },
  });
}

export function buildPostAdminVoiceTestCallPath() {
  return buildContractPath("post__admin_voice_test-call");
}
